import { render, staticRenderFns } from "./BrandTop.vue?vue&type=template&id=56d854de&scoped=true"
import script from "./BrandTop.vue?vue&type=script&lang=js"
export * from "./BrandTop.vue?vue&type=script&lang=js"
import style0 from "./BrandTop.vue?vue&type=style&index=0&id=56d854de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d854de",
  null
  
)

export default component.exports